import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import PaygroupForm from '../components/forms/PaygroupForm';
import '../styles/EmployeeMaster.css';
import PaygroupTable from '../components/PaygroupTable';

const PaygroupModel = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const showModal = location.pathname === '/paygroup/add';

  const handleAddClick = () => {
    navigate('/paygroup/add');
  };

  const handleCloseModal = () => {
    navigate('/paygroup');
  };

  return (
    <div className="employee-master-page">
      <div className="employee-header">
        <h2>Paygroup Master</h2>
        <button className="add-employee-btn" onClick={handleAddClick}>
          Add Paygroup
        </button>
      </div>

      <PaygroupTable />

      <Modal
        show={showModal}
        onHide={handleCloseModal}
        size="md"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Add New Paygroup</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <PaygroupForm />
        </Modal.Body>
        {/* <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          <Button variant="primary">
            Save
          </Button>
        </Modal.Footer> */}
      </Modal>
    </div>
  );
};

export default PaygroupModel;
